module.exports = __webpack_public_path__ + "img/PS31.85d14947.png";